import React, { Fragment } from "react";
import { Navbar as BSNavbar } from "react-bootstrap";
import { Button } from "../../Button";
import parseChildren from "../../utils/parseChildren";
import { classNames } from "../../utils/classNames";
import { useTranslation } from "../../hooks/useTranslation";
import { useStylesHook } from "../../hooks/useStylesHook";
export var HeaderNavigation = function (props) {
    var _a;
    var t = useTranslation();
    return (React.createElement(NavBar, { back: props === null || props === void 0 ? void 0 : props.back, ariaLabel: t("Page Actions and Navigation"), width: (_a = props === null || props === void 0 ? void 0 : props.width) === null || _a === void 0 ? void 0 : _a.navigation },
        (props === null || props === void 0 ? void 0 : props.tabs) && React.createElement(NavTabs, null, props === null || props === void 0 ? void 0 : props.tabs),
        (props === null || props === void 0 ? void 0 : props.navigation) && (React.createElement(NavTabs, null,
            React.createElement(HeaderNavbar, { navigation: props === null || props === void 0 ? void 0 : props.navigation }))),
        (props === null || props === void 0 ? void 0 : props.extra) && (React.createElement(NavButtons, null,
            React.createElement("div", { className: "page-nav-extra" }, props === null || props === void 0 ? void 0 : props.extra)))));
};
export var HeaderNavbar = function (_a) {
    var navigation = _a.navigation;
    return (React.createElement(Fragment, null, navigation.map(function (item, i) {
        if (item.hidden)
            return null;
        return (React.createElement(Fragment, { key: i },
            React.createElement(HeaderTab, { active: item.active, disabled: item.disabled }, item.link)));
    })));
};
export var HeaderTab = function (_a) {
    var children = _a.children, _b = _a.active, active = _b === void 0 ? false : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, key = _a.key;
    return (React.createElement("div", { className: classNames("pagenav-link", active ? "active" : "", disabled ? "disabled" : ""), key: key, role: "menuitem", "aria-disabled": disabled },
        disabled && React.createElement("div", { className: "block-link" }),
        children));
};
var NavBar = function (_a) {
    var back = _a.back, children = _a.children, ariaLabel = _a.ariaLabel, _b = _a.width, width = _b === void 0 ? "standard" : _b;
    var formChildren = parseChildren(children);
    var classes = useStylesHook({
        container: {
            "& .container-fluid": {
                paddingLeft: "8px!important",
                paddingRight: "8px!important",
            },
        },
    });
    var tabChildren = formChildren.findByType(NavTabs);
    var buttonChildren = formChildren.findByType(NavButtons);
    return (React.createElement(BSNavbar, { staticTop: true, className: classNames("page-nav", width === "full-width" ? classes.container : undefined), "aria-label": ariaLabel, role: "navigation", fluid: width === "full-width" },
        back && (React.createElement("div", { className: "page-nav-back" },
            React.createElement(Button, { label: back.label, icon: "chevron-left", onClick: back.onClick && back.onClick, disabled: back.disabled, id: back.id }))),
        React.createElement(BSNavbar.Collapse, null,
            tabChildren && tabChildren,
            buttonChildren && buttonChildren),
        (tabChildren || back || buttonChildren) && React.createElement(BSNavbar.Toggle, null)));
};
var NavButtons = function (_a) {
    var children = _a.children;
    return React.createElement(BSNavbar.Form, { pullRight: true }, children);
};
export var NavTabs = function (_a) {
    var children = _a.children, className = _a.className;
    return (React.createElement("div", { role: "menubar", className: classNames("pagenav", className) }, children));
};
